import React, { FC } from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslate } from 'react-translate-plus';
import styled from 'styled-components';

import { ReactComponent as CompanyNameSvg } from '../../assets/images/company_name.svg';
import { ReactComponent as LogoSvg } from '../../assets/images/logo.svg';
import {
  getCurrentEnvironment,
  isProdEnvironment,
  isQssEnvironment,
} from '../../interfaces/environment/Environment';

export const Logo: FC<any> = () => {
  const t = useTranslate('NavigationBar');
  const currentEnvironment = getCurrentEnvironment();
  return (
    <NavLink to="/">
      <Container>
        <LogoContainer>
          <LogoSvg />
        </LogoContainer>
        <Content>
          <CompanyName>
            <CompanyNameSvg />
          </CompanyName>
          <ProductName>
            {t('TITLE_CONFIGURATOR')}{' '}
            {currentEnvironment && !isProdEnvironment() && (
              <EnvironmentContainer isQssEnvironment={isQssEnvironment()}>
                {currentEnvironment}
              </EnvironmentContainer>
            )}
          </ProductName>
        </Content>
      </Container>
    </NavLink>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  text-align: left;
  outline: 0;
`;

const LogoContainer = styled.div`
  width: 40px;
  height: 40px;
`;

const Content = styled.div`
  display: block;
  margin-left: 8px;
  line-height: 1.2;
`;

const CompanyName = styled.div`
  display: flex;
  width: 102px;
  height: 16px;

  svg {
    width: 100%;
  }
`;

const ProductName = styled.strong`
  display: block;
  font-weight: 500;
  font-size: 1.125rem;
`;

const EnvironmentContainer = styled.span<{ isQssEnvironment: boolean }>`
  font-weight: 500;
  font-size: 1.125rem;
  color: ${({ isQssEnvironment, theme }) =>
    isQssEnvironment ? theme.colors.qssEnvironmentColor : theme.colors.environmentColor};
`;
